/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  SET_POLICY_ENTITIES_FILTERED_ITEMS,
  SET_POLICY_FORM_DATA,
  SET_POLICY_HIERARCHY_EXPANDED_ITEMS,
  SET_POLICY_HIERARCHY_ITEMS,
  SET_HIERARCHY_SELECTED_KEYS,
  SET_SELECTED_HIERARCHY,
  SET_POLICY_VALIDATION_ERROR,
  RESET_HIERARCHY_VALUES,
  RESET_POLICY_FORM_VALUES,
  SET_POLICY_MODULE_DEFAULT_VALUE,
  SET_EDIT_POLICY_FORM_DATA
} from "./types";
import {
  IDataFormError,
  ISelect
} from '../../../models/Roles/RolesContracts';

export const setPolicyFormData = (name: string, value: any) => {
  return {
    type: SET_POLICY_FORM_DATA,
    data: {
      [name]: value
    }
  };
}

export const setPolicyEntitiesFilteredItems = (entities: ISelect[]) => {
  return {
    type: SET_POLICY_ENTITIES_FILTERED_ITEMS,
    entityItems: entities
  };
}


export const setPolicyExpandedItems = (expandedItems: string[]) => {
  return {
    type: SET_POLICY_HIERARCHY_EXPANDED_ITEMS,
    expandedItems
  };
}

export const setPolicyHierarchyItems = (hierarchyItems: any) => {
  return {
    type: SET_POLICY_HIERARCHY_ITEMS,
    hierarchyItems
  };
}

export const setHierarchySelectedKeys = (selectedKeys: string[]) => {
  return {
    type: SET_HIERARCHY_SELECTED_KEYS,
    selectedKeys
  };
}

export const setHierarchySelectedHierarchy = (selectedHierarchy: string[]) => {
  return {
    type: SET_SELECTED_HIERARCHY,
    selectedHierarchy
  };
}

export const resetHierarchyValues = () => {
  return {
    type: RESET_HIERARCHY_VALUES
  };
}

export const resetPolicyFormData = () => {
  return {
    type: RESET_POLICY_FORM_VALUES
  };
}

export const updateDataFormError = (errorFormValues: IDataFormError) => {
  return {
    type: SET_POLICY_VALIDATION_ERROR,
    errorFormValues
  };
}

export const setPolicyModuleDefaultValue = () => {
  return {
    type: SET_POLICY_MODULE_DEFAULT_VALUE
  };
}

export const setEditPolicyData = (data: any) => {
  return {
    type: SET_EDIT_POLICY_FORM_DATA,
    data
  };
}